export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-primary to-accent text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/0adaafd12e96644bb3f30378f0b23f95/ff543a3bc213124683bd6341c497bd82.png"
              alt="Whiz Company"
              className="h-12 w-auto object-contain mb-6 brightness-0 invert"
            />
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              "한성은 식구食口 입니다."
            </p>
            <div className="flex gap-3">
              <a
                href="http://pf.kakao.com/_xgHVCxj"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-lg transition-colors cursor-pointer"
              >
                <img src="https://www.whizcompany.com/images/common/sns-icn1.png" alt="카카오톡" className="w-5 h-5 object-contain" />
              </a>
              <a
                href="https://www.instagram.com/whizcompany?igsh=dGk1eDJ0MTcwbmE4&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-lg transition-colors cursor-pointer"
              >
                <img src="https://www.whizcompany.com/images/common/sns-icn2.png" alt="인스타그램" className="w-5 h-5 object-contain" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">빠른 링크</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-white/80 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">서비스</h3>
            <ul className="space-y-2 text-sm text-white/80">
              <li>부동산 분양대행</li>
              <li>부동산 투자자문</li>
              <li>부동산 개발사업</li>
              <li>부동산 자산관리</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">연락처</h3>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-base mt-0.5 flex-shrink-0"></i>
                <span>경기도 안산시 단원구 광덕4로250 404호 (시티프라자)</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>1666-8482</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>hansung_2020@naver.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-white/70">
            <div>
              <p className="mb-1">사업자등록번호: 389-23-02614</p>
              <p>COPYRIGHT © hansung All rights reserved.</p>
            </div>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white/70 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
